(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunday-service-gallery"] && !Shopify.designMode) return;
  try {
    
function initSundayGallery(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const links=[...root.querySelectorAll('.ssg__tile')],dialog=root.querySelector('dialog'),large=root.querySelector('.ssg__large'),counter=root.querySelector('.ssg__counter'),open=root.querySelector('.ssg__open');
 let current=0,trigger=null,oldOverflow='',touchX=null;
 function show(index){current=(index+links.length)%links.length;const a=links[current];large.src=a.href;large.alt=a.querySelector('img').alt;open.href=a.href;counter.textContent=String(current+1).padStart(2,'0')+' / '+links.length;}
 links.forEach((a,i)=>a.addEventListener('click',e=>{e.preventDefault();trigger=a;show(i);oldOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';dialog.showModal();}));
 root.querySelector('.ssg__close').addEventListener('click',()=>dialog.close());
 root.querySelector('.ssg__prev').addEventListener('click',()=>show(current-1));root.querySelector('.ssg__next').addEventListener('click',()=>show(current+1));
 dialog.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'){e.preventDefault();show(current-1);}if(e.key==='ArrowRight'){e.preventDefault();show(current+1);}});
 dialog.addEventListener('close',()=>{document.documentElement.style.overflow=oldOverflow;large.removeAttribute('src');trigger?.focus();});
 large.addEventListener('touchstart',e=>{touchX=e.changedTouches[0].clientX;},{passive:true});large.addEventListener('touchend',e=>{if(touchX===null)return;const dx=e.changedTouches[0].clientX-touchX;if(Math.abs(dx)>50)show(current+(dx<0?1:-1));touchX=null;},{passive:true});
}
document.querySelectorAll('.ssg').forEach(initSundayGallery);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.ssg').forEach(initSundayGallery));

  } catch(e) { console.error(e); }
})();
})();
